import * as React from "react";
import type { SvgIconProps } from "../types";
import { resolveA11yProps, resolveIconSize } from "../createIcon";

export function KZIcon(props: SvgIconProps) {
  const { size, title, ...rest } = props;
  const { width, height } = resolveIconSize(size, 16, 16);
  const a11y = resolveA11yProps(props);

  return (
    <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" fill="none" width={width} height={height} {...rest} {...a11y}>{title ? <title>{title}</title> : null}<path fill="#0059ff" d="M2.352 11.636V4.364h.88v3.608h.085l3.268-3.608h1.15l-3.054 3.28 3.054 3.992H6.67l-2.53-3.38-.909 1.022v2.358z" /><path fill="#171717" d="M2.352 11.636V4.364h.88v3.608h.085l3.268-3.608h1.15l-3.054 3.28 3.054 3.992H6.67l-2.53-3.38-.909 1.022v2.358z" /><path fill="#0059ff" d="M8.634 11.636v-.639l3.92-5.852H8.591v-.781h5.014v.639l-3.92 5.852h3.963v.781z" /><path fill="#171717" d="M8.634 11.636v-.639l3.92-5.852H8.591v-.781h5.014v.639l-3.92 5.852h3.963v.781z" /></svg>
  );
}

export default KZIcon;
